import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';
import { EventGuestsService } from '../../services/event-guests.service';


import GuestPageView from "./guests.page.html";

@Component({
  selector: 'event-guests-page',
  template: GuestPageView
})
export class GuestsPage implements OnInit {
  isAllowed: boolean = false;

  constructor(@Inject(AuthService) private authService: AuthService,
              @Inject(LogService) private log: LogService,
              @Inject('$stateParams') private $stateParams: any,
              @Inject(EventGuestsService) private eventGuestsService: EventGuestsService) { }

  ngOnInit() {
    this.isAllowed = this.authService.permissionExist('GROUPS_READ') ?? false;
  }
}